module.exports = __webpack_public_path__ + "img/THV.5614b0f5.svg";